// Public fuel/powertrain vocabulary, shared with the gateway contract.
// Insurer catalogue codes and their spelling never enter the form state.
export const ENGINE_TYPE_OPTIONS = {
  petrol: "Бензин",
  diesel: "Дизел",
  electric: "Електричество",
  lpg: "Пропан-бутан (LPG)",
  cng: "Метан (CNG)",
  petrol_lpg: "Бензин / пропан-бутан",
  petrol_cng: "Бензин / метан",
  petrol_electric: "Бензин / електричество",
  diesel_electric: "Дизел / електричество",
  diesel_lpg: "Дизел / пропан-бутан",
  diesel_cng: "Дизел / метан",
  hydrogen: "Водород",
  petrol_hydrogen: "Бензин / водород",
  biofuel: "Биогориво",
  petrol_ethanol: "Бензин / етанол (E85)",
  gas: "Газ — неуточнен вид",
  petrol_gas: "Бензин / газ — неуточнен вид",
  diesel_gas: "Дизел / газ — неуточнен вид",
  hybrid: "Хибрид — неуточнен вид",
  other: "Друг",
} as const;

export type CanonicalEngineType = keyof typeof ENGINE_TYPE_OPTIONS;

export const COMMON_ENGINE_TYPES: readonly CanonicalEngineType[] = [
  "petrol", "diesel", "electric", "lpg", "cng",
  "petrol_lpg", "petrol_cng", "petrol_electric", "diesel_electric",
];

export const SELECTABLE_ENGINE_TYPES: readonly CanonicalEngineType[] = [
  ...COMMON_ENGINE_TYPES,
  "diesel_lpg", "diesel_cng", "hydrogen", "petrol_hydrogen", "biofuel", "petrol_ethanol",
];

export const isEngineType = (value: unknown): value is CanonicalEngineType =>
  typeof value === "string" && Object.hasOwn(ENGINE_TYPE_OPTIONS, value);
